import MobileTable from './Table'

export default Object.assign(MobileTable, {})
